import React, { useState, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Button,
  Modal,
  ModalHeader
} from "reactstrap"
import BootstrapTable from 'react-bootstrap-table-next'
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit'
import rest from '../../../lib/rest'
import rotas from '../../../services/rotas'
import useToggle from "../../../lib/useToggle"
import Loading from 'lib/loading'
import FormUsuario from './formUsuario'

const Usuarios = () => {

  const colunas = [
    {
      dataField: 'usuario_id',
      text: 'Código'
    },
    {
      dataField: 'usuario',
      text: 'Usuário'
    },
    {
      dataField: 'nome_perfil',
      text: 'Perfil acesso'
    },
    {
      dataField: 'ativo',
      text: 'Ativo',
      formatter: (cellContent, row) => {
        if (row.ativo == 'S' ) {
          return <div className="timeline-heading"><span className="badge badge-success badge-pill m-0 aberto">Sim</span></div>
        }else{
          return <div className="timeline-heading"><span className="badge badge-danger badge-pill m-0 aberto">Não</span></div>
        }
      }
    }
  ]

  const { SearchBar }                   = Search
  const [loading, setLoading]           = useState(true)
  const [modal, setModal]               = useToggle()
  const [listaUsuario, setListaUsuario] = useState([])
  const [usuario_id, setUsuario_id]     = useState('')

  const listaUsuarios = () => {
    let lista = []
    try{
      const retorno = rest.get(rotas.usuarios)
      retorno.then(ret => {
        if (ret.success && ret.success == 'S'){
          lista = ret.lista
          setListaUsuario(lista)
        }else{
          setListaUsuario([])
        }
        setLoading(false)
      })
      return (lista)
    }catch(err){
      console.log(err);
    }
  }

  useEffect(() => {
    const load = loading
    if (load === true) {
      listaUsuarios()
    }
  }, [])

  const abreModal = (usuario_id) => {
    setUsuario_id(usuario_id)
    setModal()
  }

  useEffect(() => {
    if(modal===false){
      listaUsuarios()
    }
  }, [modal])

  if (loading) {
    return (
      <Loading tipo='paginas' />
    )
  }else {
    return (
      <div className="content">
        <Container>
          <Row>
            <Col md="12" className="p-0">
              <Card>
                <CardHeader>
                  <CardTitle>USUÁRIOS DO PAINEL</CardTitle>
                </CardHeader>
                <CardBody>
                  <Modal
                    size    = 'xl'
                    isOpen  = {modal}
                  >
                    <ModalHeader>Usuários do Painel</ModalHeader>
                    <FormUsuario
                      usuario_id    = {usuario_id}
                      setUsuario_id = {setUsuario_id}
                      fechaModal    = {setModal}
                    ></FormUsuario>

                  </Modal>
                  <ToolkitProvider
                    search
                    keyField  = "usuario_id"
                    data      = {listaUsuario}
                    columns   = {colunas}
                    outline
                  >
                    {
                      props => (
                        <div>
                          <Container>
                            <Row>
                              <Col md="3">
                                <Button
                                  outline
                                  className = "m-0 w-100"
                                  color     = "primary"
                                  style     = {{ padding: '5px 20px' }}
                                  onClick   = {() => abreModal('')}
                                >
                                  <i className="fas fa-plus" />
                                  Cadastrar
                                </Button>
                              </Col>

                              <Col md="9">
                                <SearchBar
                                  placeholder = "Buscar Usuário..."
                                  style       = {{ padding: '5px' }}
                                  {...props.searchProps}
                                />
                              </Col>
                            </Row>
                          </Container>

                          <hr/>

                          <BootstrapTable
                            striped
                            keyField          = 'usuario_id'
                            noDataIndication  = "Nenhum registro encontrado"
                            rowStyle          = {{ cursor: "pointer" }}
                            rowEvents         = {{
                                                  onDoubleClick: (e, row, rowIndex) => {
                                                    abreModal(row.usuario_id)
                                                  }
                                                }}
                            {...props.baseProps}
                          />
                          <br/>
                        </div>
                      )
                    }
                  </ToolkitProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default Usuarios
